import { render, staticRenderFns } from "./MailboxSelection.vue?vue&type=template&id=773040a4"
import script from "./MailboxSelection.vue?vue&type=script&lang=js"
export * from "./MailboxSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports